import React, { useRef, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert, FloatingLabel } from 'react-bootstrap';
import RegBreadcrumb from '../components/RegBreadcrumb';
import PhoneInput from 'react-phone-input-2';
import { ageService } from '../functions/ageApi';
import { FieldArray, Formik, useFormikContext } from 'formik';
import * as Yup from "yup";
import { accountService } from '../functions/registerApi';
import { TailSpin } from 'react-loader-spinner';
import { authService } from '../functions/authenticate';

import 'react-phone-input-2/lib/high-res.css';
import '../scss/RegisterMember.scss';
import '../scss/RegChart.scss';
import '../scss/Register.scss';

const Register = ({ userID, setUserID, runner, marathonPrice, marathonLabel, setUserName, login, setLogin, setAuthToken, adminFee, category, size, deliveryFee, sst, tshirtTypeChangeStartDate, testAcc }) => {

    const navigate = useNavigate();

    // let tshirtCap = [150, 600, 1400, 2500, 2000, 1200, 450, 100, 65, 35];
    // let singletMaleCap = [20, 40, 200, 240, 160, 80, 40, 20, 0, 0];
    // let singletFemaleCap = [70, 160, 180, 160, 60, 50, 20, 0, 0, 0];
    // let finisher21Cap = [80, 200, 550, 970, 730, 300, 120, 40, 10, 0];
    // let finisher42Cap = [50, 140, 245, 440, 260, 110, 40, 20, 5, 0];
    let tshirtCap = [250, 700, 1500, 2600, 2100, 1300, 550, 200, 165, 135];
    let singletMaleCap = [120, 140, 300, 340, 260, 180, 140, 120, 100, 100];
    let singletFemaleCap = [170, 260, 280, 260, 160, 150, 120, 100, 100, 100];
    let finisher21Cap = [180, 300, 650, 1070, 830, 400, 220, 140, 110, 100];
    let finisher42Cap = [150, 240, 345, 540, 360, 210, 140, 120, 105, 100];

    const inputRef = useRef([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const countryList = require('../data/country.json');
    const [start, setStart] = useState(true);
    const [loading, setLoading] = useState(false);
    const [readOnly, setReadOnly] = useState(true);

    const elementRef = useRef([]);
    const elementRef2 = useRef([]);

    const [runners, setRunners] = useState({
        runner: [
            {
                individualID: '',
                paymentID: '',
                fullname: '',
                original_fullname: '',
                gender: '',
                original_gender: '',
                email: '',
                bibName: '',
                dob: '',
                original_dob: '',
                age: 0,
                nationality: '',
                mykad: '',
                original_mykad: '',
                contact: '',
                emergencyName: '',
                emergencyContact: '',
                medicalAttention: '',
                original_category: '',
                category: '',
                categoryType: 'Open',
                original_categoryType: '',
                tshirt_type: 'T-shirt',
                original_tshirt_type: 'T-shirt',
                tshirt_size: '',
                original_tshirt_size: '',
                finisher: '',
                original_finisher: '',
                racePackCollection: 'Self-Collect',
                originalRacePackCollection: '',
                deliveryAddress: '',
                deliveryPostcode: '',
                deliveryCity: '',
                deliveryState: '',
                deliveryCountry: '',
                datetime_posted: ''
            }
        ]
    });

    const [isUpdate, setIsUpdate] = useState(false);
    const [showDiv, setShowDiv] = useState([false, false, false, false]);
    const [ageCheck, setAgeCheck] = useState([[false, false, false, false]]); // set the availability for each category 
    const [ageCheckVeteran, setAgeCheckVeteran] = useState([[false, false]]); // veteran check
    const [isMarathon, setIsMarathon] = useState([false]); // check if the run is 21 or 42
    const [categoryCheck, setCategoryCheck] = useState([false]);
    const [isMe, setIsMe] = useState(false);
    const [isMyAddress, setIsMyAddress] = useState([false]);
    const [isDelivery, setIsDelivery] = useState([false]);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [notice, setNotice] = useState(false);
    const [noticeMessage, setNoticeMessage] = useState('');
    const [hasTshirt, setHasTshirt] = useState([false, false, false, false, false, false, false, false, false, false]);
    const [hasTshirt2, setHasTshirt2] = useState([
        [false, false, false, false, false, false, false, false, false, false]
    ]);
    const [hasFinisher, setHasFinisher] = useState([
        [false, false, false, false, false, false, false, false, false, false]
    ]);

    // item cart variables
    const [cartTotal, setCartTotal] = useState(0);
    const [subtotal, setSubtotal] = useState(0);
    const [tax, setTax] = useState(0);
    const [extraFee, setExtraFee] = useState(0);

    const [promo, setPromo] = useState('');

    // Enable T-shirt Type Change
    const [tshirtTypeEnable, setTshirtTypeEnable] = useState(false);


    useEffect(() => {
        const isEdit = localStorage.getItem('isEdit');
        const token = localStorage.getItem('authToken');

        if (token === '' || token === null) {
            navigate('/Login');
        }
        else {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if (!response.status) {
                        navigate('/Login');
                    }
                    else if (!login) {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);

                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }

        if (isEdit === 'true') {
            setReadOnly(true);
        } else {
            setReadOnly(false);
        }

    }, []);

    // initialize the react hook
    useEffect(() => {

        if (searchParams.get('updateToken') && searchParams.get('updateToken') !== null && searchParams.get('updateToken') !== '') {
            let updateToken = searchParams.get('updateToken');
            var data = authService.decryptUpdateToken(updateToken);
            // console.log(data);

            if (data !== false && data.userID === userID && runners.runner[0].individualID == "") {

                // let userId = localStorage.getItem('userID');
                let runnerList = localStorage.getItem('editList');
                let newRunnerList = JSON.parse(localStorage.getItem('editList'));
                // console.log(newRunnerList);

                let newLength = runner - (newRunnerList ? newRunnerList.length : 0);

                let newRunners = [];
                let newAgeCheck = [];
                let newIsMarathon = [];
                let newCategoryCheck = [];
                let newAgeCheckVeteran = [];
                let newIsMyAddress = [];
                let newHasTshirt2 = [];

                if (runnerList !== null && runnerList !== '' && newRunnerList.length > 0) {

                    if (newLength > 1) {
                        newRunners = [...runners.runner];
                        newAgeCheck = [...ageCheck];
                        newIsMarathon = [...isMarathon];
                        newCategoryCheck = [...categoryCheck];
                        newAgeCheckVeteran = [...ageCheckVeteran];
                        newIsMyAddress = [...isMyAddress];
                    }


                    newRunnerList.map(runner => {

                        var arr = [false, false, false, false];
                        var arr2 = false;
                        var arr3 = false;
                        var arr4 = [false, false];
                        var arr5 = false;

                        const age = ageService.calculateAge(runner.dob);
                        if (age >= 40) {
                            arr = [true, true, true, true];
                            arr4 = [true, true];
                        }
                        else if (age >= 18 && age < 40) {
                            arr = [true, true, true, true];
                            arr4 = [true, false];
                        }
                        else if (age >= 16 && age < 18) {
                            arr = [false, true, true, true];
                            arr4 = [true, false];
                        }
                        else if (age >= 15 && age < 16) {
                            arr = [false, false, true, true];
                            arr4 = [true, false];
                        }
                        else if (age >= 7 && age < 15) {
                            arr = [false, false, false, true];
                            arr4 = [true, false];
                        }
                        else {
                            arr = [false, false, false, false];
                            arr4 = [false, false];
                        }

                        switch (runner.category) {
                            case '42KM':
                                arr2 = true;
                                arr3 = true;
                                break;

                            case '21KM':
                                arr2 = true;
                                arr3 = true;
                                break;

                            case '10KM':
                                arr2 = false;
                                arr3 = true;
                                break;

                            case '5KM':
                                arr2 = false;
                                arr3 = true;
                                break;

                            default:
                                arr2 = false;
                                arr3 = false;
                                break;
                        }

                        newHasTshirt2.push([false, false, false, false, false, false, false, false, false, false]);

                        const obj = {
                            individualID: runner.individualID,
                            paymentID: runner.paymentID,
                            fullname: runner.fullname,
                            original_fullname: runner.fullname,
                            gender: runner.gender,
                            original_gender: runner.gender,
                            email: runner.email,
                            bibName: runner.bibName,
                            original_bibName: runner.bibName,
                            dob: runner.dob,
                            original_dob: runner.dob,
                            nationality: runner.nationality,
                            mykad: runner.mykad,
                            original_mykad: runner.mykad,
                            contact: runner.contact,
                            emergencyName: runner.emergencyName,
                            emergencyContact: runner.emergencyContact,
                            medicalAttention: runner.medicalAttention,
                            age: age,
                            original_category: runner.category,
                            category: runner.category,
                            categoryType: runner.categoryType,
                            original_categoryType: runner.categoryType,
                            tshirt_type: runner.tshirt_type,
                            original_tshirt_type: runner.tshirt_type,
                            tshirt_size: runner.tshirt_size,
                            original_tshirt_size: runner.tshirt_size,
                            finisher: runner.finisher,
                            original_finisher: runner.finisher,
                            racePackCollection: runner.racePackCollection,
                            originalRacePackCollection: runner.racePackCollection,
                            deliveryAddress: runner.deliveryAddress,
                            deliveryPostcode: runner.deliveryPostcode,
                            deliveryCity: runner.deliveryCity,
                            deliveryState: runner.deliveryState,
                            deliveryCountry: runner.deliveryCountry,
                            datetime_posted: runner.datetime_posted
                        };
                        newRunners.push(obj);

                        setHasTshirt2(newHasTshirt2);

                        newAgeCheck.push(arr);
                        newIsMarathon.push(arr2);
                        newCategoryCheck.push(arr3);
                        newAgeCheckVeteran.push(arr4);
                        newIsMyAddress.push(arr5);
                    });


                    // console.log(newRunners);


                    setAgeCheck(newAgeCheck);
                    setIsMarathon(newIsMarathon);
                    setCategoryCheck(newCategoryCheck);
                    setAgeCheckVeteran(newAgeCheckVeteran);
                    setIsMyAddress(newIsMyAddress);

                    setRunners({ runner: newRunners });

                }

                setIsUpdate(true);

            } else {
                // console.error("Invalid user");
            }
        }

        // Check where T-shirt Type Change is enable
        let today = new Date();
        let changeDt = new Date(tshirtTypeChangeStartDate);
        let tshirtTypeChangeEnable = false;
        if (today >= changeDt || testAcc.indexOf(userID) !== -1) {
            setTshirtTypeEnable(true);
            tshirtTypeChangeEnable = true;
        }

        // console.log(testAcc);
        // console.log(userID);
        // console.log(testAcc.indexOf(userID));
        // console.log(tshirtTypeChangeEnable);

    }, [userID]);

    useEffect(() => {
        // console.log(runners.runner);
        handleCap();
        if (runners.runner.length > 0) {
            runners.runner.map((runner, i) => {
                var dob = runner.dob;
                if (dob !== '' && dob !== null) {
                    const age = ageService.calculateAge(dob);
                    updateAge(age, i);
                }
            })
        }
        calculateTotal();
    }, [runners]);

    const handleBibName = (e, index) => {
        let bibName = e.target.value;
        let newRunner = [...runners.runner];

        newRunner[index].bibName = bibName;
        setRunners({ runner: newRunner });
    }

    const handleGender = (e, index) => {
        var gender = e.target.value;
        let newRunner = [...runners.runner];

        newRunner[index].gender = gender;
        setRunners({ runner: newRunner });
    }

    const handleMarathonTypeCheck = (e, index) => {
        var marathonType = e.target.value;
        updateMarathonTypeCheck(marathonType, index)
    }
    function updateMarathonTypeCheck(marathonType, index) {
        let newIsMarathon = [...isMarathon];
        let newCategoryCheck = [...categoryCheck];
        let newRunner = [...runners.runner];

        switch (marathonType) {
            case '42KM':
                newIsMarathon[index] = true;
                newCategoryCheck[index] = true;
                newRunner[index].category = '42KM';
                if (newRunner[index].age >= 40) {
                    newRunner[index].categoryType = 'Veteran';
                    newRunner[index].finisher = newRunner[index].original_finisher;
                }
                break;

            case '21KM':
                newIsMarathon[index] = true;
                newCategoryCheck[index] = true;
                newRunner[index].category = '21KM';
                if (newRunner[index].age >= 40) {
                    newRunner[index].categoryType = 'Veteran';
                    newRunner[index].finisher = newRunner[index].original_finisher;
                }
                break;

            case '10KM':
                newIsMarathon[index] = false;
                newCategoryCheck[index] = true;
                newRunner[index].category = '10KM';
                newRunner[index].finisher = '';
                newRunner[index].categoryType = 'Open';
                break;

            case '5KM':
                newIsMarathon[index] = false;
                newCategoryCheck[index] = true;
                newRunner[index].category = '5KM';
                newRunner[index].finisher = '';
                newRunner[index].categoryType = 'Open';
                break;

            default:
                newIsMarathon[index] = false;
                newCategoryCheck[index] = false;
                newRunner[index].category = '';
                break;
        }

        setIsMarathon(newIsMarathon);
        setCategoryCheck(newCategoryCheck);
        setRunners({ runner: newRunner });
        if (newRunner[index].categoryType === 'Open') {
            elementRef.current[index].click();
        } else {
            elementRef2.current[index].click();
        }

    }

    const handleCategoryTypeCheck = (categoryType, index) => {
        // var categoryType = e.target.value;
        updateCategoryTypeCheck(categoryType, index);
    }
    function updateCategoryTypeCheck(categoryType, index) {
        let newRunner = [...runners.runner];

        newRunner[index].categoryType = categoryType;
        setRunners({ runner: newRunner });
    }

    const handleShirtTypeCheck = (e, index) => {
        var shirtType = e.target.value;
        let newRunner = [...runners.runner];

        newRunner[index].tshirt_type = shirtType;
        setRunners({ runner: newRunner });
    }
    const handleTshirtCheck = (e, index) => {
        var tshirt = e.target.value;
        let newRunner = [...runners.runner];

        switch (tshirt) {
            case '2XS':
                newRunner[index].tshirt_size = '2XS';
                break;
            case 'XS':
                newRunner[index].tshirt_size = 'XS';
                break;
            case 'S':
                newRunner[index].tshirt_size = 'S';
                break;
            case 'M':
                newRunner[index].tshirt_size = 'M';
                break;
            case 'L':
                newRunner[index].tshirt_size = 'L';
                break;
            case 'XL':
                newRunner[index].tshirt_size = 'XL';
                break;
            case '2XL':
                newRunner[index].tshirt_size = '2XL';
                break;
            case '3XL':
                newRunner[index].tshirt_size = '3XL';
                break;
            case '4XL':
                newRunner[index].tshirt_size = '4XL';
                break;
            case '5XL':
                newRunner[index].tshirt_size = '5XL';
                break;
            default:
                newRunner[index].tshirt_size = '';
                break;
        }

        setRunners({ runner: newRunner });
    }
    const handleFinisher = (e, index) => {
        var finisher = e.target.value;
        let newRunner = [...runners.runner];

        switch (finisher) {
            case '2XS':
                newRunner[index].finisher = '2XS';
                break;
            case 'XS':
                newRunner[index].finisher = 'XS';
                break;
            case 'S':
                newRunner[index].finisher = 'S';
                break;
            case 'M':
                newRunner[index].finisher = 'M';
                break;
            case 'L':
                newRunner[index].finisher = 'L';
                break;
            case 'XL':
                newRunner[index].finisher = 'XL';
                break;
            case '2XL':
                newRunner[index].finisher = '2XL';
                break;
            case '3XL':
                newRunner[index].finisher = '3XL';
                break;
            case '4XL':
                newRunner[index].finisher = '4XL';
                break;
            case '5XL':
                newRunner[index].finisher = '5XL';
                break;
            default:
                newRunner[index].finisher = '';
                break;
        }

        setRunners({ runner: newRunner });
    }
    function calculateTotal() { // Calculate the total amount of the item cart
        var total = 0;
        var exFee = 0;
        var newTax = 0;
        var newSubtotal = 0;
        var isChange = false;

        runners.runner.map((values, index) => {

            let dt = new Date(values.datetime_posted);
            let earlyDate = new Date('2026-07-11 00:00:00');


            if (values.category !== '') {
                total += marathonPrice[values.category];
            }

            if (values.category !== values.original_category) {
                isChange = true;
                let tempFee = marathonPrice[values.category] - marathonPrice[values.original_category];
                if (tempFee > 0) exFee += tempFee;
                // console.log("Change category");
            }
            if (values.categoryType !== values.original_categoryType) {
                isChange = true;
                // console.log("Change category type");
            }
            if (values.bibName !== values.original_bibName) {
                isChange = true;
                // console.log("Change bib name");
            }
            if (values.tshirt_type !== values.original_tshirt_type /*&& dt > earlyDate*/) {
                isChange = true;
                console.log("Change T-shirt type");
            }
            if (values.tshirt_size !== values.original_tshirt_size /*&& dt > earlyDate*/) {
                isChange = true;
                console.log("Change T-shirt size");
            }
            if ((values.category === "42KM" || values.category === "21KM") && values.original_finisher !== values.finisher) {
                isChange = true;
                // console.log("Change finisher size");
            }

            if (values.racePackCollection !== values.originalRacePackCollection && values.racePackCollection == "Delivery Service") {
                exFee += deliveryFee;
                isChange = true;
            }

            if (values.fullname !== values.original_fullname) {
                isChange = true;
                // console.log("Change fullname");
            }

            if (values.gender !== values.original_gender) {
                isChange = true;
                // console.log("Change gender");
            }

            if (values.dob !== values.original_dob) {
                isChange = true;
                // console.log("Change date of birth");
            }

            if (values.mykad !== values.original_mykad) {
                isChange = true;
                // console.log("Change mykad or passport");
            }

            if (isChange) {
                exFee += adminFee;
                isChange = false;
            }

        });

        newSubtotal = exFee;
        newTax = newSubtotal * sst;
        exFee = newSubtotal + newTax;

        setCartTotal(total.toFixed(2));
        setSubtotal(newSubtotal.toFixed(2));
        setTax(newTax.toFixed(2));
        setExtraFee(exFee.toFixed(2));

    }
    const handleAge = (e, index) => {
        let newRunner = [...runners.runner];
        newRunner[index].dob = e.target.value;
        setRunners({ runner: newRunner });

        const age = ageService.calculateAge(e.target.value);
        // console.log(age);

        updateAge(age, index);
    }
    function updateAge(age, index) { // update the check status of the marathon type based on age
        var newAgeCheck = [false, false, false, false];
        var newAgeCheckVeteran = [false, false];
        let newRunner = [...runners.runner];
        var isRunnerUpdate = false;

        if (age >= 40) {
            newAgeCheck = [true, true, true, true];
            newAgeCheckVeteran = (runners.runner[index].category === "42KM" || runners.runner[index].category === "21KM") ? [true, true] : [true, false];
            // if(runners.runner[index].category==="42KM" || runners.runner[index].category==="21KM"){
            //     newAgeCheckVeteran = [true, true];
            //     if(newRunner[index].categoryType === "Open"){
            //         newRunner[index].categoryType = "Veteran";
            //         isRunnerUpdate = true;
            //     }
            // } else {
            //     newAgeCheckVeteran = [true, false];
            //     if(newRunner[index].categoryType === "Veteran"){
            //         newRunner[index].categoryType = "Open";
            //         isRunnerUpdate = true;
            //     }
            // }
        }
        else if (age >= 18 && age < 40) {
            newAgeCheck = [true, true, true, true];
            newAgeCheckVeteran = [true, false];
        }
        else if (age >= 16 && age < 18) {
            newAgeCheck = [false, true, true, true];
            newAgeCheckVeteran = [true, false];
        }
        else if (age >= 15 && age < 16) {
            newAgeCheck = [false, false, true, true];
            newAgeCheckVeteran = [true, false];
        }
        else if (age >= 7 && age < 15) {
            newAgeCheck = [false, false, false, true];
            newAgeCheckVeteran = [true, false];
        }
        else {
            newAgeCheck = [false, false, false, false];
            newAgeCheckVeteran = [false, false];
        }


        let newArr = [...ageCheck];
        newArr[index] = newAgeCheck;
        setAgeCheck(newArr);

        let newArr2 = [...ageCheckVeteran];
        newArr2[index] = newAgeCheckVeteran;
        setAgeCheckVeteran(newArr2);

        if (isRunnerUpdate) {
            setRunners({ runner: newRunner });
        }

    }

    const handleDelivery = (e, index) => {
        var deliveryMethod = e.target.value;
        let newRunner = [...runners.runner];
        let newIsDelivery = [...isDelivery];

        // console.log(deliveryMethod);

        if (deliveryMethod === 'Delivery Service') {
            newIsDelivery[index] = true;
        } else {
            newIsDelivery[index] = false;
        }

        setIsDelivery(newIsDelivery);

        newRunner[index].racePackCollection = deliveryMethod;
        setRunners({ runner: newRunner });

    }

    const handleIsMyAddress = (e, index) => {
        let status = e.target.checked;
        let newIsMyAddress = [...isMyAddress];

        newIsMyAddress[index] = status;
        setIsMyAddress(newIsMyAddress);

        if (status) {
            let userId = localStorage.getItem('userID');

            accountService.getUser(userId)
                .then(response => {
                    // console.log(response);

                    if (response.status) {
                        const data = response.body.user;


                    }
                    else {
                        const err = response.body;
                        setError(true);
                        setErrorMessage(err.message);
                    }
                })
                .catch(err => console.error(err));

        } else {

        }
    }

    const handleCap = () => {

        accountService.getShirtCap()
            .then((response) => {

                // console.log(response);

                var tempArr1 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr2 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr3 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr4 = [false, false, false, false, false, false, false, false, false, false];
                var tempArr5 = [false, false, false, false, false, false, false, false, false, false];

                let cap = response.body;
                let sizeArr = ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
                let tshirtSelected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let singletMaleSelected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let singletFemaleSelected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let finisher21Selected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let finisher42Selected = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

                let runnerList = localStorage.getItem('runnerList');
                let newRunnerList = JSON.parse(localStorage.getItem('runnerList'));
                let newLength = 0;

                if (runnerList !== null && runnerList !== '' && newRunnerList.length > 0) {
                    newLength = newRunnerList.length;
                } else {
                    newLength = runners.runner.length;
                }

                // console.log(newLength);
                // console.log(runners);

                // for (var i = 0; i < newLength; i++) {
                for (var i = 0; i < 5; i++) {

                    if (runners.runner[i] !== undefined && runners.runner[i] !== null && runners.runner[i].tshirt_size !== undefined && runners.runner[i].tshirt_size !== null) {

                        let key = runners.runner[i].tshirt_size;
                        let index = sizeArr.indexOf(key);
                        if (index >= 0) {
                            if (runners.runner[i].tshirt_type == "T-shirt") {
                                tshirtSelected[index]++;
                            } else if (runners.runner[i].tshirt_type == "Singlet") {
                                if (runners.runner[i].gender == "Male") {
                                    singletMaleSelected[index]++;
                                } else {
                                    singletFemaleSelected[index]++;
                                }
                            }
                        }

                        if (runners.runner[i].race_cat === '21KM') {
                            let index = sizeArr.indexOf(runners.runner[i].finisher);
                            if (index > 0) finisher21Selected[index]++;
                        } else if (runners.runner[i].race_cat === '42KM') {
                            let index = sizeArr.indexOf(runners.runner[i].finisher);
                            if (index > 0) finisher42Selected[index]++;
                        }

                    }

                }

                for (var i = 0; i < sizeArr.length; i++) {

                    var temp1 = parseInt(tshirtCap[i]) - parseInt(cap.tshirt[i]) - parseInt(tshirtSelected[i]);
                    // console.log(temp1);
                    if (temp1 > 0) {
                        tempArr1[i] = true;
                    }

                    var temp4 = parseInt(singletMaleCap[i]) - parseInt(cap.singletMale[i]) - parseInt(singletMaleSelected[i]);
                    // console.log(temp1);
                    if (temp4 > 0) {
                        tempArr4[i] = true;
                    }

                    var temp5 = parseInt(singletFemaleCap[i]) - parseInt(cap.singletFemale[i]) - parseInt(singletFemaleSelected[i]);
                    // console.log(temp1);
                    if (temp5 > 0) {
                        tempArr5[i] = true;
                    }

                    var temp2 = parseInt(finisher21Cap[i]) - parseInt(cap.finisher21[i]) - parseInt(finisher21Selected[i]);
                    // console.log(temp2);
                    if (temp2 > 0) {
                        tempArr2[i] = true;
                    }

                    var temp3 = parseInt(finisher42Cap[i]) - parseInt(cap.finisher42[i]) - parseInt(finisher42Selected[i]);
                    // console.log(temp3);
                    if (temp3 > 0) {
                        tempArr3[i] = true;
                    }

                }

                // console.log(tempArr4);
                // console.log(tempArr5);
                // console.log(newLength);

                let newHasTshirt = [];
                let newHasFinisher = [];
                // for (var i = 0; i < newLength; i++) {
                for (var i = 0; i < 5; i++) {
                    if (runners.runner[i] !== undefined && runners.runner[i] !== null && runners.runner[i].tshirt_size !== undefined && runners.runner[i].tshirt_size !== null) {

                        if (runners.runner[i].tshirt_type == "T-shirt") {
                            newHasTshirt.push(tempArr1);
                        } else if (runners.runner[i].tshirt_type == "Singlet") {
                            if (runners.runner[i].gender == "Male") {
                                newHasTshirt.push(tempArr4);
                            } else {
                                newHasTshirt.push(tempArr5);
                            }
                        } else {
                            newHasTshirt.push([false, false, false, false, false, false, false, false, false, false]);
                        }

                        if (runners.runner[i].category === '21KM') {
                            newHasFinisher.push(tempArr2);
                        } else if (runners.runner[i].category === '42KM') {
                            newHasFinisher.push(tempArr3);
                        } else {
                            newHasFinisher.push([false, false, false, false, false, false, false, false, false, false]);
                        }

                    } else {
                        newHasTshirt.push([false, false, false, false, false, false, false, false, false, false]);
                        newHasFinisher.push([false, false, false, false, false, false, false, false, false, false]);
                    }

                }


                // console.log(newHasTshirt);

                setHasTshirt(tempArr1);
                setHasTshirt2(newHasTshirt);
                setHasFinisher(newHasFinisher);

            })
            .catch((error) => {
                console.log(error);
            })
    }


    // Yup validation schema
    const validateSchema = Yup.object().shape({
        runner: Yup.array().of(
            Yup.object().shape({
                fullname: Yup.string()
                    .required("Full name is required"),

                // lastname: Yup.string()
                //     .required("Last name is required"),

                email: Yup.string().email().required("Email is required"),

                bibName: Yup.string()
                    .required("Bib name is required"),

                gender: Yup.string().required("Gender is required"),

                dob: Yup.date()
                    .max(new Date(), "Invalid date of birth, the date must be earlier than today")
                    .required("Birth date is required"),

                nationality: Yup.string()
                    .required("Nationality is required"),

                contact: Yup.string()
                    .required("Contact number is required"),

                mykad: Yup.string()
                    .required("Identity Card / Passport is required"),

                emergencyName: Yup.string()
                    .min(2, "Too Short!")
                    .max(200, "Too Long!")
                    .required("Emergency contact person's name is required"),

                emergencyContact: Yup.string()
                    .required("Emergency contact number is required"),

                category: Yup.string().required("Marathon category is required"),

                categoryType: Yup.string().required("Category type is required"),

                tshirt_size: Yup.string().required("T-shirt size is required"),

                finisher: Yup.mixed()
                    .when("category", {
                        is: (category) => category === '42KM',
                        then: () => Yup.string().required("Finisher size is required"),
                        otherwise: () => Yup.string(),
                    })
                    .when("category", {
                        is: (category) => category === '21KM',
                        then: (finisher) => Yup.string().required("Finisher size is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryAddress: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery address is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryPostcode: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery postcode is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryCity: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery city is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryState: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery state is required"),
                        otherwise: () => Yup.string(),
                    }),

                deliveryCountry: Yup.mixed()
                    .when("racePackCollection", {
                        is: (racePackCollection) => racePackCollection === 'Delivery Service',
                        then: () => Yup.string().required("Delivery country is required"),
                        otherwise: () => Yup.string(),
                    }),
            })
        )
    });


    const handlePromo = (e) => {
        setPromo(e.target.value);
        localStorage.setItem('promoCode', promo);

        // let newRunner = [...runners.runner];
        // let len = newRunner.length;
        // for(var i=0; i<len; i++){
        //     newRunner[i].category = '';
        // }
        // setRunners({runner: newRunner});

        promoFunction(e.target.value);

    }

    const promoFunction = (value) => {
        accountService.checkPromo(value)
            .then((response) => {
                // console.log(response);

                if (response.status) {

                    let data = response.body.code;
                    let count = response.body.count;
                    let diff = parseInt(data.quantity) - (parseInt(runner) + parseInt(count));

                    if (diff < 0) {
                        alert('You had exceed the limit of the participants you can register. You had registered ' + count + ' participant(s).');
                        localStorage.removeItem('promoCode');
                        navigate('/Register');
                    } else {
                        if (data.payment_type === 'Sponsored') {

                            let temp = [true, true, true, true];
                            let index = 3;

                            switch (data.race_cat) {
                                case '42KM':
                                    index = 0;
                                    break;
                                case '21KM':
                                    index = 1;
                                    break;
                                case '10KM':
                                    index = 2;
                                    break;
                                case '5KM':
                                    index = 3;
                                    break;
                            }

                            temp[index] = false;
                            setShowDiv(temp);

                            setNoticeMessage('Group Code ' + data.code + ' has been applied.');
                            setNotice(true);

                        } else if (data.payment_type === 'Invoicing') {
                            setNoticeMessage('Group Code ' + data.code + ' has been applied.');
                            setNotice(true);
                        } else if (data.payment_type === 'Online Payment') {
                            setNoticeMessage('Group Code ' + data.code + ' has been applied.');
                            setNotice(true);
                        }
                    }

                } else {
                    let temp = [false, false, false, false];
                    setShowDiv(temp);
                    setNotice(false);
                    setNoticeMessage('');
                }

            })
            .catch(err => {
                console.error(err.response);
            });
    }

    const handleBack = () => {
        navigate("/Profile/registration");
    }

    // On submit handler
    const submitForm = (values) => {
        setLoading(true);
        let userId = localStorage.getItem('userID');
        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');

        // console.log(values);

        accountService.updateRegistration(values, userID)
            .then((response) => {

                // console.log(response);

                if (response.status) {
                    // update the promo code applied
                    localStorage.setItem('promoCode', promo);
                    // set the current paymentID
                    localStorage.setItem('paymentID', response.body.paymentID);
                    localStorage.setItem('updateList', response.body.remarks);
                    localStorage.setItem('updateExtraFee', response.body.extraFee);

                    setLoading(false);
                    // navigate('/UPayment');

                    let data = response.body;
                    if (data.extraFee > 0) {
                        navigate('/UPayment');
                    } else {

                        var userAgent = navigator.userAgent.toLowerCase();
                        var Android = userAgent.indexOf("android") > -1;
                        var iOS = userAgent.indexOf("ios") > -1;

                        if (Android) {
                            localStorage.removeItem('device');
                            window.open(`https://www.marathonkuching.com/mobileApp`);
                        } else if (iOS) {
                            localStorage.removeItem('device');
                            window.open(`kuchingMarathonApp://`);
                        } else {
                            navigate('/Profile/registration');
                        }

                    }
                }
                else {
                    console.error(response.body.message);
                    setError(true);
                    setErrorMessage(response.body.message);
                    setLoading(false);
                    window.scrollTo(0, 0);
                }

            })
            .catch(err => {
                console.error(err.response);
                setError(true);
                setErrorMessage(err.message);
                setLoading(false);
            });
    }




    return (
        <Container fluid="lg" className='wrapper'>
            <h1 className="title">Marathon Registration</h1>

            <RegBreadcrumb page={1} />

            <br />

            <Col md={12} xs={12}>
                <Alert variant="danger">
                    {/* UPGRADE/DOWNGRADE FEE - Any edits to Run Category will require a RM40 fee. */}
                    ADMIN FEE - Any edits to registration will require additional RM20 fee.
                    <br />
                    CONTACT US : <a href="mailto:support@marathonkuching.com">support@marathonkuching.com</a>
                </Alert>
            </Col>

            {error && (
                <Col md={12} xs={12}>
                    <Alert variant="danger" onClose={() => { setError(false); setIsMe(false) }} dismissible>
                        {errorMessage}
                    </Alert>
                </Col>
            )}

            {notice && (
                <Col md={12} xs={12}>
                    <Alert variant="success" onClose={() => { setNotice(false); setNoticeMessage('') }} dismissible>
                        {noticeMessage}
                    </Alert>
                </Col>
            )}

            <Formik
                enableReinitialize={true}
                initialValues={runners}
                validationSchema={validateSchema}
                onSubmit={submitForm}
            >
                {({ values, handleChange, handleSubmit, errors, touched, handleBlur, isValid, dirty }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row className="runner-detail mb-5">
                            <Col md={8} xs={12} >

                                <ScrollToFieldError />

                                <FieldArray
                                    name="runners"
                                >
                                    {arrayHelpers => (
                                        <>
                                            {values.runner && values.runner.length > 0 && values.runner.map((runner, index) => (
                                                <div key={index}>

                                                    {/* {errors && errors.runner && console.log(errors.runner)} */}
                                                    {/* {values && values.runner && console.log(values.runner)} */}
                                                    {/* {console.log(values)} */}

                                                    <h3 className="short-title "  >Runner {index + 1}</h3>

                                                    <div className="regForm mb-4">
                                                        <Row className="mb-3">
                                                            <h4>Runner's Details</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom01">
                                                                <FloatingLabel controlId="floatingPromo" label="Full name">
                                                                    <Form.Control
                                                                        required
                                                                        readOnly
                                                                        name={`runner.${index}.fullname`}
                                                                        type="text"
                                                                        placeholder="Full name"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].fullname}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].fullname &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].fullname
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].fullname
                                                                        }

                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].fullname}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom02">
                                                                <FloatingLabel controlId="floatingPromo" label="Bib Name">
                                                                    <Form.Control
                                                                        required
                                                                        name={`runner.${index}.bibName`}
                                                                        type="text"
                                                                        placeholder="Bib Name"
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            handleBibName(e, index);
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].bibName}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].bibName &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].bibName
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].bibName
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].bibName}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom03">
                                                                <FloatingLabel controlId="floatingPromo" label="Email">
                                                                    <Form.Control
                                                                        required
                                                                        readOnly
                                                                        name={`runner.${index}.email`}
                                                                        type="text"
                                                                        placeholder="Email"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].email}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].email &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].email
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].email
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].email}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="6" className="mb-2" controlId="validationCustom04">
                                                                <FloatingLabel controlId="floatingPromo" label="IC / Passport">
                                                                    <Form.Control
                                                                        required
                                                                        readOnly
                                                                        name={`runner.${index}.mykad`}
                                                                        type="text"
                                                                        placeholder="IC / Passport"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].mykad}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].mykad &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].mykad
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].mykad
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].mykad}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="4" controlId="validationCustom05">
                                                                <FloatingLabel controlId="floatingPromo" label="Date of Birth">
                                                                    <Form.Control
                                                                        required
                                                                        readOnly
                                                                        name={`runner.${index}.dob`}
                                                                        type="date"
                                                                        onChange={(e) => {
                                                                            handleChange(e)
                                                                            handleAge(e, index)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].dob}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].dob &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].dob
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].dob
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].dob}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group className="mb-2" as={Col} md="3" controlId="validationCustom06">
                                                                <FloatingLabel controlId="floatingPromo" label="Gender">
                                                                    <Form.Control
                                                                        required
                                                                        readOnly
                                                                        name={`runner.${index}.gender`}
                                                                        type="text"
                                                                        onChange={(e) => {
                                                                            handleChange(e)
                                                                            handleAge(e, index)
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        value={values.runner[index].gender}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].gender &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].gender
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].gender
                                                                        }
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].gender}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group className="mb-2" as={Col} md="5" controlId="validationCustom07">
                                                                <FloatingLabel controlId="floatingPromo" label="Nationality">
                                                                    <Form.Select
                                                                        disabled={readOnly}
                                                                        aria-label="Default select example"
                                                                        name={`runner.${index}.nationality`}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].nationality}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].nationality &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].nationality
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].nationality
                                                                        }
                                                                    >
                                                                        <option style={{ background: '#fff', color: '#777' }} key="" value="">Nationality</option>
                                                                        {
                                                                            countryList.map(data => (
                                                                                <option style={{ background: '#fff', color: '#777' }} key={data.country} value={data.country}>{data.country}</option>
                                                                            ))
                                                                        }
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].nationality}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group as={Col} md="5" className="mb-2 phone-float-input" controlId="validationCustom08">
                                                                <FloatingLabel controlId="floatingPromo" label="Contact No">
                                                                    <PhoneInput
                                                                        disabled={readOnly}
                                                                        id="select-input"
                                                                        name={`runner.${index}.contact`}
                                                                        className={
                                                                            "form-control " +
                                                                            (errors && errors.runner && errors.runner[index] && !!errors.runner[index].contact ? "is-invalid" : "") + " " +
                                                                            (touched.runner && touched.runner[index] && touched.runner[index].contact && errors && errors.runner && errors.runner[index] && !errors.runner[index].contact ? "is-valid" : "")
                                                                        }
                                                                        country={'my'}
                                                                        inputProps={{
                                                                            name: `runner.${index}.contact`,
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        onChange={(phoneNumber, country, e) => { handleChange(e) }}
                                                                        value={values.runner[index].contact}
                                                                    />
                                                                    <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].contact} hidden />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].contact}</Form.Control.Feedback>
                                                                </FloatingLabel>

                                                            </Form.Group>
                                                        </Row>

                                                        <br /><br />

                                                        <Row className="mb-3">
                                                            <h4>Emergency Contact</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="7" controlId="validationCustom09">
                                                                <FloatingLabel controlId="floatingPromo" label="Full Name">
                                                                    <Form.Control
                                                                        required
                                                                        readOnly={readOnly}
                                                                        name={`runner.${index}.emergencyName`}
                                                                        type="text"
                                                                        placeholder="Full Name"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].emergencyName}
                                                                        isValid={
                                                                            touched.runner && touched.runner[index] && touched.runner[index].emergencyName &&
                                                                            errors.runner && errors.runner[index] && !errors.runner[index].emergencyName
                                                                        }
                                                                        isInvalid={
                                                                            errors && errors.runner && errors.runner[index] && !!errors.runner[index].emergencyName
                                                                        }

                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].emergencyName}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                            <Form.Group as={Col} md="5" className="mb-2  phone-float-input" controlId="validationCustom10">
                                                                <FloatingLabel controlId="floatingPromo" label="Contact No">
                                                                    <PhoneInput
                                                                        disabled={readOnly}
                                                                        id="select-input"
                                                                        name={`runner.${index}.emergencyContact`}
                                                                        className={
                                                                            "form-control " +
                                                                            (errors && errors.runner && errors.runner[index] && !!errors.runner[index].emergencyContact ? "is-invalid" : "") + " " +
                                                                            (touched.runner && touched.runner[index] && touched.runner[index].emergencyContact && errors.runner && errors.runner[index] && !errors.runner[index].contact ? "is-valid" : "")
                                                                        }
                                                                        country={'my'}
                                                                        inputProps={{
                                                                            name: `runner.${index}.emergencyContact`,
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        onChange={(phoneNumber, country, e) => { handleChange(e) }}
                                                                        value={values.runner[index].emergencyContact}
                                                                    />
                                                                    <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].emergencyContact} hidden />
                                                                    <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].emergencyContact}</Form.Control.Feedback>
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="12" controlId="validationCustom11">
                                                                <FloatingLabel controlId="floatingPromo" label="Medical Attention">
                                                                    <Form.Control
                                                                        required
                                                                        readOnly={readOnly}
                                                                        name={`runner.${index}.medicalAttention`}
                                                                        type="text"
                                                                        placeholder="Medical Attention"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.runner[index].medicalAttention}
                                                                    />
                                                                </FloatingLabel>
                                                            </Form.Group>
                                                        </Row>

                                                        <br /><br />

                                                        <Row className="mb-3">
                                                            <h4>Race Category</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="12" controlId="validationCustom12">
                                                                {category.map((category, categoryIndex) => (
                                                                    <Form.Check
                                                                        key={categoryIndex}
                                                                        inline
                                                                        label={category}
                                                                        name={`runner.${index}.category`}
                                                                        type="radio"
                                                                        id={`inline-radio"-` + categoryIndex}
                                                                        value={category}
                                                                        disabled={!ageCheck[index][categoryIndex] || readOnly}
                                                                        checked={(runner.category === category ? true : false)}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            handleMarathonTypeCheck(e, index);
                                                                        }}
                                                                        isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].category}

                                                                        className={showDiv[categoryIndex] ? 'd-none' : ''}
                                                                    />
                                                                ))}
                                                                <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].category} hidden />
                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].category}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Row>
                                                        <Row className='mb-3'>
                                                            <Form.Group className="mb-2" as={Col} md="12" controlId="validationCustom13">
                                                                <label htmlFor="" className="sub-label">Category :</label>
                                                                <Form.Check
                                                                    ref={ref => { elementRef.current[index] = ref }}
                                                                    inline
                                                                    label="Open"
                                                                    name={`runner.${index}.categoryType`}
                                                                    type="radio"
                                                                    id={`inline-radio-1`}
                                                                    value="Open"
                                                                    disabled={!ageCheckVeteran[index][0] || readOnly}
                                                                    checked={(runner.categoryType === "Open" ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleCategoryTypeCheck("Open", index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].categoryType}
                                                                />
                                                                <Form.Check
                                                                    ref={ref => { elementRef2.current[index] = ref }}
                                                                    inline
                                                                    label="Veteran"
                                                                    name={`runner.${index}.categoryType`}
                                                                    type="radio"
                                                                    id={`inline-radio-2`}
                                                                    value="Veteran"
                                                                    disabled={!ageCheckVeteran[index][1] || readOnly}
                                                                    checked={(runner.categoryType === "Veteran" ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleCategoryTypeCheck("Veteran", index);
                                                                    }}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].categoryType}
                                                                />
                                                                <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].categoryType} hidden />
                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].categoryType}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Row>

                                                        <br /><br />

                                                        <Row >
                                                            <h4>T-shirt Size</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className='mb-3'>
                                                            <Form.Group className="mb-2" as={Col} md="12" >
                                                                <b style={{ color: "white", }}>Size Chart</b>
                                                                <ol style={{ color: "white", }}>
                                                                    <li><small>Unisex T-shirt: <a href="https://www.marathonkuching.com/site/wp-content/uploads/2026/05/KM26-Event-Tee_Size-Chart-1024x1024.png" target="_blank">view</a></small></li>
                                                                    <li><small>Male Singlet: <a href="https://www.marathonkuching.com/site/wp-content/uploads/2026/05/KM26-Male_Singlet-Size-Chart-3-1024x1024.png" target="_blank">view</a></small></li>
                                                                    <li><small>Female Singlet: <a href="https://www.marathonkuching.com/site/wp-content/uploads/2026/05/KM26-Female_Singlet-Size-Chart-1024x1024.png" target="_blank">view</a></small></li>
                                                                </ol>
                                                                <label className="sub-label mt-3">Running Shirt Type :</label>
                                                                <Form.Check
                                                                    inline
                                                                    label="T-shirt"
                                                                    id={`runner.${index}.tshirt_type1`}
                                                                    name={`runner.${index}.tshirt_type`}
                                                                    type="radio"
                                                                    value="T-shirt"
                                                                    checked={(runner.tshirt_type === "T-shirt" ? true : false)}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleShirtTypeCheck(e, index);
                                                                    }}
                                                                    disabled={readOnly}
                                                                    isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_type}
                                                                />
                                                                {tshirtTypeEnable && (<>
                                                                    <Form.Check
                                                                        inline
                                                                        label="Singlet"
                                                                        id={`runner.${index}.tshirt_type2`}
                                                                        name={`runner.${index}.tshirt_type`}
                                                                        type="radio"
                                                                        value="Singlet"
                                                                        checked={(runner.tshirt_type === "Singlet" ? true : false)}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            handleShirtTypeCheck(e, index);
                                                                        }}
                                                                        disabled={readOnly}
                                                                        isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_type}
                                                                    />
                                                                </>)}
                                                                <Form.Control id={`runner.${index}.tshirt_typeSelected`} isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_type} hidden />
                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].tshirt_type}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Row>

                                                        {runner.tshirt_type != "" && (
                                                            <>
                                                                <Row className="mb-3">
                                                                    <Form.Group className="mb-2" as={Col} md="12" controlId="validationCustom14">
                                                                        {size.map((size, sizeIndex) => (
                                                                            <Form.Check
                                                                                key={sizeIndex}
                                                                                inline
                                                                                label={size}
                                                                                name={`runner.${index}.tshirt_size`}
                                                                                type="radio"
                                                                                value={size}
                                                                                id={`tshirt-` + (sizeIndex + 1)}
                                                                                // disabled={!categoryCheck[index] || readOnly}
                                                                                disabled={!hasTshirt2[index][sizeIndex] || readOnly}
                                                                                onChange={(e) => {
                                                                                    handleChange(e);
                                                                                    handleTshirtCheck(e, index);
                                                                                }}
                                                                                checked={(runners.runner[index].tshirt_size === size ? true : false)}
                                                                                isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_size}
                                                                            />
                                                                        ))}
                                                                        <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].tshirt_size} hidden />
                                                                        <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].tshirt_size}</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Row>
                                                            </>
                                                        )}

                                                        {isMarathon[index] && (
                                                            <>
                                                                <br /><br />
                                                                <Row className="mb-3">
                                                                    <h4>Finisher Size</h4>
                                                                    <hr />
                                                                </Row>
                                                                <Row className="mb-3">
                                                                    <Form.Group className="mb-2" as={Col} md="12" controlId="validationCustom15">
                                                                        {size.map((size, sizeIndex) => (
                                                                            <Form.Check
                                                                                key={sizeIndex}
                                                                                inline
                                                                                label={size}
                                                                                name={`runner.${index}.finisher`}
                                                                                type="radio"
                                                                                id={`finisher-` + (sizeIndex + 1)}
                                                                                disabled={!isMarathon[index] || readOnly}
                                                                                onChange={(e) => {
                                                                                    handleChange(e);
                                                                                    handleFinisher(e, index);
                                                                                }}
                                                                                checked={(runners.runner[index].finisher === size ? true : false)}
                                                                                value={size}
                                                                                isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].finisher}
                                                                            />
                                                                        ))}
                                                                        <Form.Control isInvalid={errors && errors.runner && errors.runner[index] && !!errors.runner[index].finisher} hidden />
                                                                        <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].finisher}</Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Row>
                                                            </>
                                                        )}

                                                        <br /><br />

                                                        <Row className="mb-3">
                                                            <h4>Race Pack Collection</h4>
                                                            <hr />
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Form.Group className="mb-2" as={Col} md="12" >
                                                                <Form.Check
                                                                    inline
                                                                    disabled={readOnly}
                                                                    label="Self Collect"
                                                                    id={`colection-1`}
                                                                    name={`runner.${index}.racePackCollection`}
                                                                    type="radio"
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleDelivery(e, index);
                                                                    }}
                                                                    checked={(runners.runner[index].racePackCollection === 'Self-Collect' ? true : false)}
                                                                    value="Self-Collect"
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    disabled={readOnly}
                                                                    label="Delivery Service"
                                                                    id={`collection-2`}
                                                                    name={`runner.${index}.racePackCollection`}
                                                                    type="radio"
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        handleDelivery(e, index);
                                                                    }}
                                                                    checked={(runners.runner[index].racePackCollection === 'Delivery Service' ? true : false)}
                                                                    value="Delivery Service"
                                                                />
                                                            </Form.Group>

                                                            {isDelivery[index] && (
                                                                <>
                                                                    <Form.Group className="mb-1 mt-2" id="formGridCheckbox">
                                                                        <Row style={{ color: 'white' }}>
                                                                            <Col md="12">
                                                                                <h5>Courier Service Partner :</h5>
                                                                                <img style={{ marginLeft: '10px', width: '200px' }} src="https://marathonkuching.com/register/images/pos_malaysia_2026.png" />
                                                                                <br />
                                                                                <strong style={{ fontSize: '2rem' }}>Pos Malaysia Berhad</strong>
                                                                            </Col>
                                                                        </Row>
                                                                        {/* <Form.Check
                                                                            disabled={readOnly}
                                                                            type="checkbox"
                                                                            label="Use my address"
                                                                            onChange={(e) => { handleIsMyAddress(e, index) }}
                                                                            checked={isMyAddress[index]}
                                                                            value="true"
                                                                        /> */}
                                                                    </Form.Group>

                                                                    <Row className="mb-3">
                                                                        <Form.Group className="mb-2" as={Col} md="12" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryAddress`} label="Address">
                                                                                <Form.Control
                                                                                    required
                                                                                    as="textarea"
                                                                                    placeholder="Address"
                                                                                    style={{ height: '100px' }}
                                                                                    name={`runner.${index}.deliveryAddress`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryAddress}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryAddress &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryAddress
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryAddress
                                                                                    }
                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryAddress}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryPostcode`} label="Postcode">
                                                                                <Form.Control
                                                                                    required
                                                                                    name={`runner.${index}.deliveryPostcode`}
                                                                                    type="text"
                                                                                    placeholder="Postcode"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryPostcode}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryPostcode &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryPostcode
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryPostcode
                                                                                    }

                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryPostcode}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryCity`} label="City">
                                                                                <Form.Control
                                                                                    required
                                                                                    name={`runner.${index}.deliveryCity`}
                                                                                    type="text"
                                                                                    placeholder="City"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryCity}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryCity &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryCity
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryCity
                                                                                    }

                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryCity}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryState`} label="State">
                                                                                <Form.Control
                                                                                    required
                                                                                    name={`runner.${index}.deliveryState`}
                                                                                    type="text"
                                                                                    placeholder="Last name"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryState}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryState &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryState
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryState
                                                                                    }

                                                                                />
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryState}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                        <Form.Group className="mb-2" as={Col} md="6" >
                                                                            <FloatingLabel controlId={`runner.${index}.deliveryCountry`} label="Country">
                                                                                <Form.Select
                                                                                    aria-label="Default select example"
                                                                                    name={`runner.${index}.deliveryCountry`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    value={values.runner[index].deliveryCountry}
                                                                                    isValid={
                                                                                        touched.runner && touched.runner[index] && touched.runner[index].deliveryCountry &&
                                                                                        errors.runner && errors.runner[index] && !errors.runner[index].deliveryCountry
                                                                                    }
                                                                                    isInvalid={
                                                                                        errors && errors.runner && errors.runner[index] && !!errors.runner[index].deliveryCountry
                                                                                    }
                                                                                >
                                                                                    <option key="" value="">Select a country</option>
                                                                                    <option key="Malaysia" value="Malaysia">Malaysia</option>
                                                                                    {/* <option key="Singapore" value="Singapore">Singapore</option> */}
                                                                                    {/* <option key="Brunei" value="Brunei">Brunei</option> */}
                                                                                </Form.Select>
                                                                                <Form.Control.Feedback type="invalid">{errors && errors.runner && errors.runner[index] && errors.runner[index].deliveryCountry}</Form.Control.Feedback>
                                                                            </FloatingLabel>
                                                                        </Form.Group>
                                                                    </Row>
                                                                </>
                                                            )}

                                                        </Row>

                                                    </div>


                                                </div>
                                            ))}
                                        </>
                                    )}
                                </FieldArray>

                            </Col>

                            <Col md={4} xs={12} >
                                <div id="regChart" className="mTop5">

                                    <Row className="chartTitle">
                                        <h5>Summary</h5>
                                    </Row>

                                    <hr />

                                    <Row className="chartDesc">
                                        <h6>Kuching Marathon 2026</h6>
                                    </Row>

                                    <div className="chartItemBox">
                                        <ul className="chartItemList">
                                            {runners.runner && runners.runner.length > 0 && runners.runner.map((values, index) => (
                                                <li key={index}>
                                                    <div className="subChartTitle">
                                                        <h6>{values.fullname === "" ? "Participant " + index + 1 : values.fullname}</h6>
                                                    </div>
                                                    <div className="subChartDetail">
                                                        <p className='subChartDetailLeft' style={values.category === values.original_category ? { marginBottom: 0 } : { marginBottom: 0, textDecoration: "line-through" }}>
                                                            {marathonLabel[values.original_category]}
                                                        </p>
                                                        <p className='subChartDetailRight' style={values.category === values.original_category ? { marginBottom: 0 } : { marginBottom: 0, textDecoration: "line-through" }}>
                                                            RM {marathonPrice[values.original_category]}
                                                        </p>
                                                        <p className='subChartDetailLeft' style={{ marginBottom: 0 }}>
                                                            {values.category === values.original_category ? '' : marathonLabel[values.category]}
                                                        </p>
                                                        <p className='subChartDetailRight' style={{ marginBottom: 0 }}>
                                                            {values.category === values.original_category ? '' : 'RM ' + marathonPrice[values.category]}
                                                        </p>
                                                        {values.racePackCollection === 'Delivery Service' && (
                                                            <>
                                                                <p className='subChartDetailLeft' style={{ marginBottom: 0 }}>
                                                                    Delivery Service
                                                                </p>
                                                                <p className='subChartDetailRight' style={{ marginBottom: 0 }}>
                                                                    RM 20
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>
                                                    <br />
                                                </li>
                                            ))}
                                            {runners.runner.length === 0 && (
                                                <div className="subChartEmpty">
                                                    <h6>Item cart is empty.</h6>
                                                </div>
                                            )}
                                        </ul>
                                    </div>

                                    <hr />

                                    {!readOnly && (
                                        <>
                                            <Row className="promo">
                                                <FloatingLabel controlId="floatingPromo" label="Promo Code">
                                                    <Form.Control type="text" placeholder="Promo Code" onChange={handlePromo} />
                                                </FloatingLabel>
                                            </Row>
                                            <hr />
                                        </>
                                    )}

                                    {/* <hr />

                                    <Row style={{paddingTop: 0, paddingBottom:0}} className="chartTotal chartItemList">
                                        <div className="chartTotal subChartDetail">
                                            <p style={{margin: 0}} className='chartTotalLeft subChartDetailLeft'>Total</p>
                                            <p style={{margin: 0}} className='chartTotalRight subChartDetailRight'>RM <span>{cartTotal}</span></p>
                                        </div>
                                    </Row> */}



                                    <Row style={{ paddingTop: 0 }} className="chartTotal chartItemList">
                                        {!readOnly && (
                                            <>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Admin Fee</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{extraFee > 0 ? '20.00' : '0.00'}</span></p>
                                                </div>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Subtotal</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{subtotal}</span></p>
                                                </div>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Tax (8%)</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{tax}</span></p>
                                                </div>
                                                <div className="chartTotal subChartDetail">
                                                    <p className='chartTotalLeft subChartDetailLeft'>Extra Fee</p>
                                                    <p className='chartTotalRight subChartDetailRight'>RM <span>{extraFee}</span></p>
                                                </div>
                                            </>
                                        )}
                                        <Col>
                                            <Button onClick={handleBack} type="button" variant="secondary" className="btn form-control d-flex justify-content-center">
                                                Back
                                            </Button>
                                        </Col>
                                        {!readOnly && (
                                            <Col>
                                                <Button type="submit" className="btn red-button form-control d-flex justify-content-center">
                                                    Update &nbsp;
                                                    <TailSpin
                                                        height="18"
                                                        width="18"
                                                        color="#ccc"
                                                        ariaLabel="tail-spin-loading"
                                                        radius="2"
                                                        wrapperStyle={{}}
                                                        wrapperClass="loader"
                                                        visible={loading}
                                                    />
                                                </Button>
                                            </Col>
                                        )}
                                    </Row>

                                </div>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>

        </Container>
    );
}

export default Register;

export const getFieldErrorNames = (formikErrors) => {
    const transformObjectToDotNotation = (obj, prefix = '', result = []) => {
        Object.keys(obj).forEach((key) => {
            const value = obj[key]
            if (!value) return

            const nextKey = prefix ? `${prefix}.${key}` : key
            if (typeof value === 'object') {
                transformObjectToDotNotation(value, nextKey, result)
            } else {
                result.push(nextKey)
            }
        })

        return result
    }

    return transformObjectToDotNotation(formikErrors)
}

export const ScrollToFieldError = ({
    scrollBehavior = { behavior: 'smooth', block: 'center' },
}) => {
    const { submitCount, isValid, errors } = useFormikContext()

    useEffect(() => {
        if (isValid) return

        const fieldErrorNames = getFieldErrorNames(errors)
        if (fieldErrorNames.length <= 0) return


        const element = document.querySelector(
            `input[name='${fieldErrorNames[0]}']`
        )
        if (!element) return

        // Scroll to first known error into view
        element.scrollIntoView(scrollBehavior)

        // Formik doesn't (yet) provide a callback for a client-failed submission,
        // thus why this is implemented through a hook that listens to changes on
        // the submit count.
    }, [submitCount]) // eslint-disable-line react-hooks/exhaustive-deps

    return null
}


